export default __webpack_public_path__ + "static/media/habano-3Closed.c642d322.jpg";